const errorMessage = {
    'Network Error'                      : '网络异常，请重试',
    'Request failed with status code 404': '服务器异常，请稍后再试'
};

export function ajaxErrorMessage(message) {
    return errorMessage[message] || message || '请求失败';
}
